import { Container, Grid, Typography, Box, Link } from "@mui/material";
import React from "react";
import NotFound from "../../Assets/oops.png";
import { useNavigate } from "react-router-dom";
interface PageNotFoundProps {
  pageNotFound: boolean;
}
export const PageNotFound: React.FunctionComponent<PageNotFoundProps> = (
  props
) => {
  const navigate = useNavigate();
  return (
    <>
      <Container component="div">
        <Grid
          container
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Grid item>
            <Typography noWrap component="div" sx={{ flexGrow: 1, mt: 2 }}>
              <img src={NotFound}></img>
            </Typography>
            <Box
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Typography fontSize="1rem" textAlign="center">
                {props.pageNotFound
                  ? "Sorry, the page you’re looking for does not exist."
                  : "Invalid URL. Please enter a valid URL to access store."}
              </Typography>
              {props.pageNotFound ? (
                <>
                  Go To
                  <Link
                    ml={0.5}
                    onClick={() => navigate("/")}
                    underline="none"
                    sx={{ cursor: "pointer" }}
                  >
                    Dashboard
                  </Link>
                </>
              ) : null}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
